import { SCard } from 'app/components/StaycationUI';

import './Accessibility.scss';
import { LastMinuteRule } from './_components/LastMinuteRule';
import { MaxAddonQuantity } from './_components/MaxAddonQuantity';

export enum TIME_UNIT {
  HOURS = 'hours',
  DAYS = 'days',
}

export const Limitations = () => (
  <SCard
    title="Limitations"
    className="experience-form limitations-form"
    subtitle="Configure rules to restrict the activity's booking availability."
  >
    <LastMinuteRule prefix="Remove availability" />
    <MaxAddonQuantity />
  </SCard>
);
